export default __webpack_public_path__ + "static/media/me-icon-active.1c4041e7.webp";